/* eslint-disable new-cap */
export default class SpritePool {
  constructor (type, length, parentRef) {
    this.pool = [];
    let i = length;
    while (--i > -1) {
      this.pool[i] = new type(parentRef);
    }
  }

  getSprite() {
    if (this.pool.length > 0) {
      return this.pool.pop();
    }
    else {
      return null;
    }
  };

  returnSprite(sprite) {
    this.pool.push(sprite);
  };
}